﻿export interface IErrorInformation {
    errorMessage: string;
    errorDetails: string;
}

export class ErrorInformation implements IErrorInformation {
    public errorMessage: string;
    public errorDetails: string;
}